module.exports = __webpack_public_path__ + "img/edit.2de7540b.svg";